<template>
  <div class=" mt-5">
    <hr />
    <div v-if="data.type == 1" class="float-right">
      <button class="btn btn-secondary px-4" :class="{ active: activeFilter === 'All' }" @click="sortAnswer('All')">
        All
      </button>
      <template v-for="(item, index) in [1, 2, 3, 4, 5]">
        <button class="btn btn-secondary px-4" :class="{ active: activeFilter === String(item) }"
          @click="sortAnswer(String(item))">
          {{ item }}
        </button>
      </template>
    </div>

    <div v-if="data.type == 2" class="float-right">
      <button class="btn btn-secondary px-4" :class="{ active: activeFilter === 'All' }" @click="sortAnswer('All')">
        All
      </button>
      <button class="btn btn-secondary px-4" :class="{ active: activeFilter === 'Yes' }" @click="sortAnswer('Yes')">
        Yes
      </button>
      <button class="btn btn-secondary px-4" :class="{ active: activeFilter === 'No' }" @click="sortAnswer('No')">
        No
      </button>
    </div>
    <div class="pt-4">
      <TableComponent :id="'answer-tbl'" :title="data.question" :headers="[
        { label: 'No.', width: '5%' },
        { label: 'IC Number', width: '20%' },
        { label: 'Name', width: '35%' },
        { label: 'Answers', width: '40%' }
      ]" :data="answers" :fields="['index', 'ic_number', 'name', 'answer']" />
    </div>
  </div>
</template>

<script>
import TableComponent from "./table.vue";

export default {
  name: "AnswerTable",

  components: {
    TableComponent
  },

  props: {
    data: {
      type: Object,
      default: () => ({ answers: [], question: "" })
    }
  },

  data() {
    return {
      answers: [],
      question: "",
      activeFilter: "All"
    };
  },

  watch: {
    data: {
      handler(newVal, oldVal) {
        this.destroyDatatable();
      },
      deep: true
    },
    answer: {
      handler(newVal, oldVal) {
        this.destroyDatatable();
      },
      deep: true
    }
  },

  computed: {
    filteredData() {
      if (this.activeFilter === "All") {
        return this.data.answers;
      }
      return this.data.answers.filter(
        item => item.answer === this.activeFilter
      );
    }
  },

  methods: {
    loadDatatable(tableId) {
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`)
          .DataTable()
          .destroy();
      }

      $(`#${tableId}`).DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: ["excel"]
      });
    },
    destroyDatatable() {
      ["answer-tbl"].forEach(tableId => {
        if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
          $(`#${tableId}`)
            .DataTable()
            .destroy();
        }
      });

      this.$nextTick(() => {
        this.loadDatatable("answer-tbl");
      });
    },

    loadTable() {
      $("#call_log_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: ["excel", "pdf"],
        bDestroy: true
      });
    },

    sortAnswer(filter) {
      this.activeFilter = filter;
      if (filter === "All") {
        this.answers = this.data.answers;
      } else {
        this.answers = this.data.answers.filter(item => item.answer === filter);
      }
      this.destroyDatatable("#answer-tbl");
      this.$nextTick(() => {
        this.loadTable("#answer-tbl");
      });
    }
  },

  async mounted() {
    if (this.data.answers && this.data.answers.length) {
      this.sortAnswer("All");
    }
    this.$nextTick(() => {
      this.setDatatable();
    });
  },

  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newData) {
        if (newData.answers && newData.answers.length) {
          this.answers = newData.answers;
          this.sortAnswer("All");
        }
      }
    }
  }
};
</script>
